import { toUnicode } from 'idna-uts46-hx';
import { randomInt } from 'crypto';

class ConsoleTracer {
    trace(msg, ...args) {
        console.debug(`[${new Date().toISOString()}] TezosDomains`, msg, ...args);
    }
}
class NoopTracer {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    trace() { }
}

var SmartContractType;
(function (SmartContractType) {
    SmartContractType["TLDRegistrar"] = "tldRegistrar";
    SmartContractType["NameRegistry"] = "nameRegistry";
    SmartContractType["OracleRegistrar"] = "oracleRegistrar";
})(SmartContractType || (SmartContractType = {}));
var TLDConfigProperty;
(function (TLDConfigProperty) {
    TLDConfigProperty["MAX_COMMITMENT_AGE"] = "0";
    TLDConfigProperty["MIN_COMMITMENT_AGE"] = "1";
    TLDConfigProperty["MIN_BID_PER_DAY"] = "2";
    TLDConfigProperty["MIN_DURATION"] = "3";
    TLDConfigProperty["MIN_BID_INCREASE_RATIO"] = "4";
    TLDConfigProperty["MIN_AUCTION_PERIOD"] = "5";
    TLDConfigProperty["BID_ADDITIONAL_PERIOD"] = "6";
    TLDConfigProperty["DEFAULT_LAUNCH_DATE"] = "1000";
    TLDConfigProperty["DEFAULT_STANDARD_PRICE"] = "2000";
})(TLDConfigProperty || (TLDConfigProperty = {}));
class NotSupportedError extends Error {
    constructor() {
        super('Method not supported.');
    }
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

const BuiltInAddresses = {
    mainnet: {
        'nameRegistry:set_child_record': {
            address: 'KT1QHLk1EMUA8BPH3FvRUeUmbTspmAhb7kpd',
        },
        'nameRegistry:update_record': {
            address: 'KT1H1MqmUM4aK9i1833EBmYCCEfkbt6ZdSBc',
        },
        'nameRegistry:claim_reverse_record': {
            address: 'KT1TnTr6b2YxSx2xUQ8Vz3MoWy771ta66yGx',
        },
        'nameRegistry:update_reverse_record': {
            address: 'KT1J9VpjiH5cmcsskNb8gEXpBtjD4zrAx4Vo',
        },
        nameRegistry: {
            address: 'KT1F7JKNqwaoLzRsMio1MQC7zv3jG9dHcDdJ',
            resolveProxyContract: true,
        },
        'tldRegistrar:tez:commit': {
            address: 'KT1P8n2qzJjwMPbHJfi4o8xu6Pe3gaU3u2A3',
        },
        'tldRegistrar:tez': {
            address: 'KT1P8n2qzJjwMPbHJfi4o8xu6Pe3gaU3u2A3',
            resolveProxyContract: true,
        },
        'tldRegistrar:tez:buy': {
            address: 'KT191reDVKrLxU9rjTSxg53wRqj6zh8pnHgr',
        },
        'tldRegistrar:tez:renew': {
            address: 'KT1EVYBj3f1rZHNeUtq4ZvVxPTs77wuHwARU',
        },
        'tldRegistrar:tez:bid': {
            address: 'KT1CaSP4dn8wasbMsfdtGiCPgYFW7bvnPRRT',
        },
        'tldRegistrar:tez:withdraw': {
            address: 'KT1CfuAbJQbAGYcjKfvEvbtNUx45LY5hfTVR',
        },
        'tldRegistrar:tez:settle': {
            address: 'KT1MeFfi4TzSCc8CF9j3qq5mecTPdc6YVUPp',
        },
        oracleRegistrar: {
            address: 'KT1MMkh1VMT8d5BVuBP2whf7RXCWeMdUfkXu',
        },
    },
    custom: null,
    ghostnet: {
        'nameRegistry:set_child_record': {
            address: 'KT1HpddfW7rX5aT2cTdsDaQZnH46bU7jQSTU',
        },
        'nameRegistry:update_record': {
            address: 'KT1Ln4t64RdCG1bK8zkH6Xi4nNQVxz7qNgyj',
        },
        'nameRegistry:claim_reverse_record': {
            address: 'KT1H19ouy5QwDBchKXcUw1QRFs5ZYyx1ezEJ',
        },
        'nameRegistry:update_reverse_record': {
            address: 'KT1HDUc2xtPHqWQcjE1WuinTTHajXQN3asdk',
        },
        nameRegistry: {
            address: 'KT1B3j3At2XMF5P8bVoPD2WeJbZ9eaPiu3pD',
            resolveProxyContract: true,
        },
        'tldRegistrar:gho:commit': {
            address: 'KT1PEnPDgGKyHvaGzWj6VJJYwobToiW2frff',
        },
        'tldRegistrar:gho': {
            address: 'KT1PEnPDgGKyHvaGzWj6VJJYwobToiW2frff',
            resolveProxyContract: true,
        },
        'tldRegistrar:gho:buy': {
            address: 'KT1Ks7BBTLLjD9PsdCboCL7fYEfq8z1mEvU1',
        },
        'tldRegistrar:gho:renew': {
            address: 'KT1Bv32pdMYmBJeMa2HsyUQZiC6FNj1dX6VR',
        },
        'tldRegistrar:gho:bid': {
            address: 'KT1P3wdbusZK2sj16YXxRViezzWCPXpiE28P',
        },
        'tldRegistrar:gho:withdraw': {
            address: 'KT1C7EF4c1pnPW9qcfNRiTPj5tBFMQJtvUhq',
        },
        'tldRegistrar:gho:settle': {
            address: 'KT1DMNPg3b3fJQpjXULcXjucEXfwq3zGTKGo',
        },
        'tldRegistrar:a1:commit': {
            address: 'KT1PiEKNUgDyr4gA5Z5WE6Vi7e9MKjre6Vyy',
        },
        'tldRegistrar:a1': {
            address: 'KT1PiEKNUgDyr4gA5Z5WE6Vi7e9MKjre6Vyy',
            resolveProxyContract: true,
        },
        'tldRegistrar:a1:buy': {
            address: 'KT1C6uf5vhzjwcpNvKdQWMVg8JxFswXrurGD',
        },
        'tldRegistrar:a1:renew': {
            address: 'KT1GE4S9PqFx7RMzuA26oXRYf9iJXnMdMyDn',
        },
        'tldRegistrar:a1:bid': {
            address: 'KT1K9teWXfPPozW5VBUegPvUVgtXrnoJidV7',
        },
        'tldRegistrar:a1:withdraw': {
            address: 'KT1WMQnp2sFF7r2ECYW35prfjYFrxVczaEat',
        },
        'tldRegistrar:a1:settle': {
            address: 'KT1NBWg6RK6CH2hhvtQWofadqVeDa8MEEWmc',
        },
        'tldRegistrar:a2:commit': {
            address: 'KT1RnBSGukTTEN6NzcNVyZcArGx2VKdsL4uU',
        },
        'tldRegistrar:a2': {
            address: 'KT1RnBSGukTTEN6NzcNVyZcArGx2VKdsL4uU',
            resolveProxyContract: true,
        },
        'tldRegistrar:a2:buy': {
            address: 'KT1GUfkv3jMMuKhVwu8NFck4DHGynS3YLkn4',
        },
        'tldRegistrar:a2:renew': {
            address: 'KT1JNxJ46cJTk37Lc2fdGs7WgSwNGbimaxcr',
        },
        'tldRegistrar:a2:bid': {
            address: 'KT1VN7wyuRjXAD8W4GMCC78NAcXFv4GKY8aA',
        },
        'tldRegistrar:a2:withdraw': {
            address: 'KT1FFNsV26cY2AbtR7H6vbdAX3dQp3nk6iTj',
        },
        'tldRegistrar:a2:settle': {
            address: 'KT1WzbK971hoRBtPuifq6Dp2wsw3Fp2uodNL',
        },
        'tldRegistrar:a3:commit': {
            address: 'KT18eVEy9H2gCKZqZ3gc4ZN7EhvSPNQEwSmc',
        },
        'tldRegistrar:a3': {
            address: 'KT18eVEy9H2gCKZqZ3gc4ZN7EhvSPNQEwSmc',
            resolveProxyContract: true,
        },
        'tldRegistrar:a3:buy': {
            address: 'KT1TtPKzV94QQr4cAXV7GtiXPV95cgBhiweD',
        },
        'tldRegistrar:a3:renew': {
            address: 'KT1G3TCBEpjTR8YnZ4j3D6pehs7Xwodnng4U',
        },
        'tldRegistrar:a3:bid': {
            address: 'KT1EaiCWMt5vbqjpmjw9Wq8gxqLWFEzaPMWG',
        },
        'tldRegistrar:a3:withdraw': {
            address: 'KT1VkfPjHEjvhuinsKBEZCGgx7LMapVsVERs',
        },
        'tldRegistrar:a3:settle': {
            address: 'KT1LFMdquFkEUVu9Xf5aAtNR3BF25sprz7qh',
        },
    },
    jakartanet: {
        'nameRegistry:set_child_record': {
            address: 'KT1Djax3uKS6JXvJguSkikmSDZDErdvYyx5P',
        },
        'nameRegistry:update_record': {
            address: 'KT1UQgpYo7M996L2xFV9TiqPVehM1TAs4uXs',
        },
        'nameRegistry:claim_reverse_record': {
            address: 'KT1C1JVViEw63rKCkxATX3jfK3UKjqF1cdxf',
        },
        'nameRegistry:update_reverse_record': {
            address: 'KT1PQ95cfVprPtDyBGCmR3vU3Un88EESTyuR',
        },
        nameRegistry: {
            address: 'KT1LZRsvqcA4cXtYKPxX9RwzT6DgdYCRuWbs',
            resolveProxyContract: true,
        },
        'tldRegistrar:jak:commit': {
            address: 'KT1EWKKYfuF32Uk136HHqdc4v195S7PieWzY',
        },
        'tldRegistrar:jak': {
            address: 'KT1EWKKYfuF32Uk136HHqdc4v195S7PieWzY',
            resolveProxyContract: true,
        },
        'tldRegistrar:jak:buy': {
            address: 'KT1Hzv2HpL57bwr14nFJerCVYiMZkQqxD8ZA',
        },
        'tldRegistrar:jak:renew': {
            address: 'KT1MPh1VZVSksqWF5mbiGbuagWmJzQShNMrd',
        },
        'tldRegistrar:jak:bid': {
            address: 'KT1LdAxSSKfLU3Deb15REh11xKhjpLCuQYGZ',
        },
        'tldRegistrar:jak:withdraw': {
            address: 'KT1SsKFchZUY8etQddpAvDZPdKKJoV5bA52Q',
        },
        'tldRegistrar:jak:settle': {
            address: 'KT1MAd6GKkVzohoeV172bYpwoyqLD5GLdmad',
        },
        'tldRegistrar:a1:commit': {
            address: 'KT1Pr7Xg9WDM4v1PzUMcZhDiUM8sZMGmz4Ut',
        },
        'tldRegistrar:a1': {
            address: 'KT1Pr7Xg9WDM4v1PzUMcZhDiUM8sZMGmz4Ut',
            resolveProxyContract: true,
        },
        'tldRegistrar:a1:buy': {
            address: 'KT1Pc374xTzGxDS8gaNobM6LmPhT4qMaUYfY',
        },
        'tldRegistrar:a1:renew': {
            address: 'KT1RY6FiUVKmuEUn4HiMKh328DqBbmJj6Av2',
        },
        'tldRegistrar:a1:bid': {
            address: 'KT1Sg2jeDWgp4tmU6pPaVq22eUnanGq6ZugY',
        },
        'tldRegistrar:a1:withdraw': {
            address: 'KT1DysPuUrtxQZtDDdfbf3WiT5wpXi8SVdio',
        },
        'tldRegistrar:a1:settle': {
            address: 'KT1PJjogYRWXDHqEFfieaM3i2UDxT4xx4fNQ',
        },
        'tldRegistrar:a2:commit': {
            address: 'KT19SfZnLUYgF3VUPNCC5ZoHALjHSXkEYcQG',
        },
        'tldRegistrar:a2': {
            address: 'KT19SfZnLUYgF3VUPNCC5ZoHALjHSXkEYcQG',
            resolveProxyContract: true,
        },
        'tldRegistrar:a2:buy': {
            address: 'KT1FARWoPasPM83WrwKbc3s3jzJFMQ6Rq2VP',
        },
        'tldRegistrar:a2:renew': {
            address: 'KT1DfTw7orWqGSUxkg7a5A7anbDgdA9JD3Uf',
        },
        'tldRegistrar:a2:bid': {
            address: 'KT19Knt9rfrxonqNTWjBNTdpgpJxAyQqJBuX',
        },
        'tldRegistrar:a2:withdraw': {
            address: 'KT1GVjXc5Y57qJFP85ptCztVMgmCRQWpBjLa',
        },
        'tldRegistrar:a2:settle': {
            address: 'KT1CmiKt5dtkdSKyoue4DCzwCzJrMi5Xr8Nk',
        },
        'tldRegistrar:a3:commit': {
            address: 'KT1UhwBDqQiRQayubhEiJPZpokpWWBafvBSi',
        },
        'tldRegistrar:a3': {
            address: 'KT1UhwBDqQiRQayubhEiJPZpokpWWBafvBSi',
            resolveProxyContract: true,
        },
        'tldRegistrar:a3:buy': {
            address: 'KT1WvXu7LQh4ZhQJjJS9iEQ4bfCY15gEHXqM',
        },
        'tldRegistrar:a3:renew': {
            address: 'KT1TbEroXmHidC4E4Dpqry42Pr2nv5XWKaHB',
        },
        'tldRegistrar:a3:bid': {
            address: 'KT1H54eCmPugM7JsGz96M2VrsMChN98wFrC4',
        },
        'tldRegistrar:a3:withdraw': {
            address: 'KT1UzYfUSTzC2PxAZ6yiA9yXWof1kSntkWLV',
        },
        'tldRegistrar:a3:settle': {
            address: 'KT1F2P5VweUnN5YNMLtpfSh2SSe61TzdaoA6',
        },
        oracleRegistrar: {
            address: 'KT1GBZDGVJ85Sg4t3ppjGiRn4382fPeo3f3T',
        },
    },
};

class AddressBook {
    constructor(proxyContractAddressResolver, config) {
        this.proxyContractAddressResolver = proxyContractAddressResolver;
        const network = (config === null || config === void 0 ? void 0 : config.network) || 'mainnet';
        if (network === 'custom' && !(config === null || config === void 0 ? void 0 : config.contractAddresses)) {
            throw new Error(`When network type is 'custom', it is required to specify 'contractAddresses'.`);
        }
        if (config === null || config === void 0 ? void 0 : config.contractAddresses) {
            this.config = config.contractAddresses;
        }
        else {
            const addresses = BuiltInAddresses[network];
            if (!addresses) {
                throw new Error(`Built in address configuration for network ${network} not found. Supported built-in networks are: ${Object.keys(BuiltInAddresses)
                    .filter(n => n !== 'custom')
                    // eslint-disable-next-line sonarjs/no-nested-template-literals
                    .map(n => `'${n}'`)
                    .join(', ')}.`);
            }
            this.config = addresses;
        }
    }
    lookup(type, ...params) {
        return __awaiter(this, void 0, void 0, function* () {
            const alias = this.buildAlias(type, params, type === SmartContractType.TLDRegistrar ? 1 : 0);
            const addressDescriptor = this.config[alias];
            if (!addressDescriptor) {
                throw new Error(`Address for contract ${alias} is not configured.`);
            }
            if (addressDescriptor.resolveProxyContract) {
                return yield this.proxyContractAddressResolver.getAddress(addressDescriptor.address);
            }
            return addressDescriptor.address;
        });
    }
    buildAlias(type, params, minParams) {
        const specifiedParameters = params.filter(p => !!p);
        if (specifiedParameters.length < minParams) {
            throw new Error(`Lookup of address for type ${type} requires at least ${minParams} parameter(s).`);
        }
        return [type].concat(specifiedParameters).join(':');
    }
}

const rpcTypes = new Map();
const DATA_STORAGE_PROPERTY = '__data__';
function RpcRequest() {
    return function (target) {
        rpcTypes.set(target, 'request');
    };
}
function RpcResponse() {
    return function (target) {
        rpcTypes.set(target, 'response');
    };
}
function ensureStorage(obj) {
    obj[DATA_STORAGE_PROPERTY] = obj[DATA_STORAGE_PROPERTY] || {};
}
function encoder(encoder) {
    return function (target, propertyKey) {
        const encoderInstance = new encoder();
        const getter = function () {
            ensureStorage(this);
            return this[DATA_STORAGE_PROPERTY][propertyKey];
        };
        const setter = function (newVal) {
            ensureStorage(this);
            const type = rpcTypes.get(target.constructor);
            if (!type) {
                throw new Error('In order to use encoder() decorator, the class must be decorated with either RpcRequest() or RpcResponse()');
            }
            this[DATA_STORAGE_PROPERTY][propertyKey] = type === 'request' ? encoderInstance.encode(newVal) : encoderInstance.decode(newVal);
        };
        Object.defineProperty(target, propertyKey, {
            get: getter,
            set: setter,
        });
    };
}

class RpcRequestData {
    static fromValue(value, encoder) {
        return new RpcRequestScalarData(value, encoder);
    }
    static fromObject(type, data) {
        return new RpcRequestObjectData(type, data);
    }
}
class RpcRequestScalarData extends RpcRequestData {
    constructor(rawValue, encoder) {
        super();
        this.rawValue = rawValue;
        this.encoder = encoder;
    }
    get originalValue() {
        return this.rawValue;
    }
    encode() {
        if (this.encoder) {
            const encoderInstance = new this.encoder();
            return encoderInstance.encode(this.rawValue);
        }
        return (this.rawValue || null);
    }
}
class RpcRequestObjectData extends RpcRequestData {
    constructor(type, rawValue) {
        super();
        this.type = type;
        this.rawValue = rawValue;
    }
    get originalValue() {
        return this.rawValue;
    }
    encode() {
        const result = new this.type();
        Object.assign(result, this.rawValue);
        return result;
    }
}

class RpcResponseData {
    constructor(rawValue) {
        this.rawValue = rawValue;
    }
    scalar(encoder) {
        if (!encoder) {
            return (this.rawValue || null);
        }
        const encoderInstance = new encoder();
        return encoderInstance.decode(this.rawValue);
    }
    decode(type) {
        if (!this.rawValue) {
            return null;
        }
        const result = new type();
        Object.assign(result, this.rawValue);
        return result;
    }
}

function encodeString(str) {
    let result = '';
    const encoded = new TextEncoder().encode(str);
    for (let i = 0; i < encoded.length; i++) {
        const hexchar = encoded[i].toString(16);
        result += hexchar.length == 2 ? hexchar : '0' + hexchar;
    }
    return result;
}
function decodeString(hexString) {
    return new TextDecoder().decode(hexToArray(hexString));
}
function hexToArray(hexString) {
    var _a;
    return new Uint8Array(((_a = hexString.match(/.{1,2}/g)) === null || _a === void 0 ? void 0 : _a.map(byte => parseInt(byte, 16))) || []);
}
function safeJsonParse(jsonString) {
    try {
        return JSON.parse(jsonString);
    }
    catch (_a) {
        return null;
    }
}
function normalizeDomainName(name) {
    return toUnicode(name, { useStd3ASCII: false });
}

class JsonBytesEncoder {
    encode(value) {
        if (!value) {
            return null;
        }
        return encodeString(JSON.stringify(value));
    }
    decode(value) {
        if (!value) {
            return null;
        }
        return safeJsonParse(decodeString(value));
    }
}

var StandardRecordMetadataKey;
(function (StandardRecordMetadataKey) {
    StandardRecordMetadataKey["TTL"] = "td:ttl";
    StandardRecordMetadataKey["GRAVATAR_HASH"] = "gravatar:hash";
    StandardRecordMetadataKey["OPENID_SUB"] = "openid:sub";
    StandardRecordMetadataKey["OPENID_NAME"] = "openid:name";
    StandardRecordMetadataKey["OPENID_GIVEN_NAME"] = "openid:given_name";
    StandardRecordMetadataKey["OPENID_FAMILY_NAME"] = "openid:family_name";
    StandardRecordMetadataKey["OPENID_MIDDLE_NAME"] = "openid:middle_name";
    StandardRecordMetadataKey["OPENID_NICKNAME"] = "openid:nickname";
    StandardRecordMetadataKey["OPENID_PREFERRED_USERNAME"] = "openid:preferred_username";
    StandardRecordMetadataKey["OPENID_PROFILE"] = "openid:profile";
    StandardRecordMetadataKey["OPENID_PICTURE"] = "openid:picture";
    StandardRecordMetadataKey["OPENID_WEBSITE"] = "openid:website";
    StandardRecordMetadataKey["OPENID_EMAIL"] = "openid:email";
    StandardRecordMetadataKey["OPENID_EMAIL_VERIFIED"] = "openid:email_verified";
    StandardRecordMetadataKey["OPENID_GENDER"] = "openid:gender";
    StandardRecordMetadataKey["OPENID_BIRTHDATE"] = "openid:birthdate";
    StandardRecordMetadataKey["OPENID_ZONEINFO"] = "openid:zoneinfo";
    StandardRecordMetadataKey["OPENID_LOCALE"] = "openid:locale";
    StandardRecordMetadataKey["OPENID_PHONE_NUMBER"] = "openid:phone_number";
    StandardRecordMetadataKey["OPENID_PHONE_NUMBER_VERIFIED"] = "openid:phone_number_verified";
    StandardRecordMetadataKey["OPENID_ADDRESS"] = "openid:address";
    StandardRecordMetadataKey["TWITTER"] = "twitter:handle";
    StandardRecordMetadataKey["INSTAGRAM"] = "instagram:handle";
    StandardRecordMetadataKey["GITHUB_PROFILE"] = "github:username";
    StandardRecordMetadataKey["GITLAB_PROFILE"] = "gitlab:username";
    StandardRecordMetadataKey["KEYBASE"] = "keybase:username";
    StandardRecordMetadataKey["REPOSITORY_URL"] = "project:repository_url";
    StandardRecordMetadataKey["WEB_CONTENT_URL"] = "web:content_url";
    StandardRecordMetadataKey["WEB_REDIRECT_URL"] = "web:redirect_url";
})(StandardRecordMetadataKey || (StandardRecordMetadataKey = {}));
class RecordMetadata {
    constructor(data) {
        this.data = data || {};
    }
    raw() {
        return this.data;
    }
    get(key, encoder) {
        return new RpcResponseData(this.data[key]).scalar(encoder);
    }
    getJson(key) {
        return this.get(key, JsonBytesEncoder);
    }
    set(key, value, encoder) {
        const encodedValue = RpcRequestScalarData.fromValue(value, encoder).encode();
        if (encodedValue) {
            this.data[key] = encodedValue;
        }
        else {
            this.delete(key);
        }
    }
    delete(key) {
        delete this.data[key];
    }
    setJson(key, value) {
        this.set(key, value, JsonBytesEncoder);
    }
    keys() {
        return Object.keys(this.data);
    }
}

class BytesEncoder {
    encode(value) {
        if (!value) {
            return null;
        }
        return encodeString(value);
    }
    decode(value) {
        if (!value) {
            return null;
        }
        return decodeString(value);
    }
}

class NormalizeBytesEncoder extends BytesEncoder {
    encode(value) {
        if (!value) {
            return null;
        }
        return super.encode(normalizeDomainName(value));
    }
    decode(value) {
        return super.decode(value);
    }
}

class DateEncoder {
    encode(value) {
        if (!value) {
            return null;
        }
        return value.toISOString();
    }
    decode(value) {
        if (!value) {
            return null;
        }
        return new Date(value);
    }
}

function createTracer(config) {
    return config.tracing ? new ConsoleTracer() : new NoopTracer();
}

/** Get the tld part of the domain name. (i.e. `tez` if domain name is `bob.alice.tez`) */
function getTld(name) {
    const tokens = tokenizeDomainName(name);
    return tokens[tokens.length - 1];
}
/** Get the label part of the domain name. (i.e. `bob` if domain name is `bob.alice.tez`) */
function getLabel(name) {
    const tokens = tokenizeDomainName(name);
    return tokens.length > 1 ? tokens[0] : '';
}
/** Get the parent part of the domain name. (i.e. `alice.tez` if domain name is `bob.alice.tez`) */
function getParent(name) {
    return tokenizeDomainName(name).slice(1).join('.');
}
/** Get the domain name without the tld. (i.e. `bob.alice` if domain name is `bob.alice.tez`) */
function stripTld(name) {
    const tokens = tokenizeDomainName(name);
    return tokens.slice(0, tokens.length - 1).join('.');
}
/** Get the domain level (i.e. 3, if domain name is `bob.alice.tez`) */
function getLevel(name) {
    const tokens = tokenizeDomainName(name);
    return tokens.length;
}
/** Splits the domain name into parts divided by `.` characters. */
function tokenizeDomainName(name) {
    return name.split('.');
}

var DomainNameValidationResult;
(function (DomainNameValidationResult) {
    DomainNameValidationResult["INVALID_TLD"] = "INVALID_TLD";
    DomainNameValidationResult["VALID"] = "VALID";
    DomainNameValidationResult["UNSUPPORTED_CHARACTERS"] = "UNSUPPORTED_CHARACTERS";
    DomainNameValidationResult["INVALID_NAME"] = "INVALID_NAME";
    DomainNameValidationResult["TOO_LONG"] = "TOO_LONG";
    DomainNameValidationResult["TOO_SHORT"] = "TOO_SHORT";
})(DomainNameValidationResult || (DomainNameValidationResult = {}));
const LatinDomainNameValidator = (name) => {
    if (name.length < 1) {
        return DomainNameValidationResult.TOO_SHORT;
    }
    const parts = tokenizeDomainName(name);
    for (const part of parts) {
        if (part.length > 100) {
            return DomainNameValidationResult.TOO_LONG;
        }
        if (!/^[a-z0-9-]+$/.test(part)) {
            return DomainNameValidationResult.UNSUPPORTED_CHARACTERS;
        }
    }
    return DomainNameValidationResult.VALID;
};
const LengthDomainNameValidator = (name, tld) => {
    if (name.length < 1) {
        return DomainNameValidationResult.TOO_SHORT;
    }
    const noSpaceResult = NoSpacesValidator(name, tld);
    if (noSpaceResult !== DomainNameValidationResult.VALID) {
        return noSpaceResult;
    }
    const parts = tokenizeDomainName(name);
    for (const part of parts) {
        if (part.length > 100) {
            return DomainNameValidationResult.TOO_LONG;
        }
        if (!part) {
            return DomainNameValidationResult.UNSUPPORTED_CHARACTERS;
        }
    }
    return DomainNameValidationResult.VALID;
};
const NoSpacesValidator = (name, tld = '') => {
    return /\s+/.test(tld) || /\s+/.test(name) ? DomainNameValidationResult.UNSUPPORTED_CHARACTERS : DomainNameValidationResult.VALID;
};

const BuiltInTLDs = {
    mainnet: [{ name: 'tez', validator: LatinDomainNameValidator }],
    ghostnet: [
        { name: 'gho', validator: LatinDomainNameValidator },
        { name: 'a1', validator: LatinDomainNameValidator },
        { name: 'a2', validator: LatinDomainNameValidator },
        { name: 'a3', validator: LatinDomainNameValidator },
    ],
    jakartanet: [
        { name: 'jak', validator: LatinDomainNameValidator },
        { name: 'a1', validator: LatinDomainNameValidator },
        { name: 'a2', validator: LatinDomainNameValidator },
        { name: 'a3', validator: LatinDomainNameValidator },
    ],
    custom: null,
};

class TezosDomainsValidator {
    constructor(config) {
        this.validators = new Map();
        this.claimableValidators = new Map();
        this.tlds = [];
        this.claimableTlds = [];
        const network = (config === null || config === void 0 ? void 0 : config.network) || 'mainnet';
        if (network === 'custom' && !(config === null || config === void 0 ? void 0 : config.tlds)) {
            throw new Error(`When network type is 'custom', it is required to specify 'tlds'.`);
        }
        let tlds;
        if (config === null || config === void 0 ? void 0 : config.tlds) {
            tlds = config.tlds;
        }
        else {
            tlds = BuiltInTLDs[network];
            if (!tlds) {
                throw new Error(`Built in tlds configuration for network ${network} not found. Supported built-in networks are: ${Object.keys(BuiltInTLDs)
                    .filter(n => n !== 'custom')
                    // eslint-disable-next-line sonarjs/no-nested-template-literals
                    .map(n => `'${n}'`)
                    .join(', ')}.`);
            }
        }
        if (config === null || config === void 0 ? void 0 : config.claimableTlds) {
            config.claimableTlds.forEach(t => this.addClaimableTld(t.name, t.validator));
        }
        tlds.forEach(tld => this.addSupportedTld(tld.name, tld.validator));
    }
    get supportedTLDs() {
        return this.tlds.concat(this.claimableTlds);
    }
    isClaimableTld(tld) {
        return this.claimableTlds.includes(tld);
    }
    validateDomainName(name, options = { minLevel: 1 }) {
        try {
            name = normalizeDomainName(name);
        }
        catch (err) {
            return DomainNameValidationResult.INVALID_NAME;
        }
        const level = getLevel(name);
        if (level < (options === null || options === void 0 ? void 0 : options.minLevel)) {
            return DomainNameValidationResult.INVALID_NAME;
        }
        if (level === 1) {
            return NoSpacesValidator(name);
        }
        const tld = getTld(name);
        const nameWithoutTld = stripTld(name);
        return LengthDomainNameValidator(nameWithoutTld, tld);
    }
    isValidWithKnownTld(name) {
        var _a;
        try {
            name = normalizeDomainName(name);
        }
        catch (err) {
            return DomainNameValidationResult.INVALID_NAME;
        }
        if (this.tlds.includes(name) || this.claimableTlds.includes(name)) {
            // tld itself
            return DomainNameValidationResult.VALID;
        }
        const tld = getTld(name);
        const nameWithoutTld = stripTld(name);
        if (!this.supportedTLDs.includes(tld)) {
            return DomainNameValidationResult.INVALID_TLD;
        }
        const validator = (_a = this.validators.get(tld)) !== null && _a !== void 0 ? _a : this.claimableValidators.get(tld);
        return validator(nameWithoutTld, tld);
    }
    addSupportedTld(tld, validator) {
        this.tlds.push(tld);
        this.validators.set(tld, validator);
    }
    addClaimableTld(tld, validator) {
        this.claimableTlds.push(tld);
        this.claimableValidators.set(tld, validator);
    }
    removeSupportedTld(tld) {
        this.tlds = this.tlds.filter(tld => tld !== tld);
        this.validators.delete(tld);
    }
    removeClaimableTld(tld) {
        this.claimableTlds = this.claimableTlds.filter(tld => tld !== tld);
        this.claimableValidators.delete(tld);
    }
}

class UnsupportedDomainNameValidator {
    get supportedTLDs() {
        return [];
    }
    validateDomainName() {
        return DomainNameValidationResult.INVALID_NAME;
    }
    isValidWithKnownTld() {
        return DomainNameValidationResult.INVALID_TLD;
    }
    isClaimableTld() {
        throw new Error('Method not implemented.');
    }
    addSupportedTld() {
        throw new NotSupportedError();
    }
    removeSupportedTld() {
        throw new NotSupportedError();
    }
}

class ResolverDataProviderAdapter {
    constructor(tezosDomainsDataProvider, tracer) {
        this.tezosDomainsDataProvider = tezosDomainsDataProvider;
        this.tracer = tracer;
    }
    resolveDomainInfo(name) {
        return __awaiter(this, void 0, void 0, function* () {
            this.tracer.trace(`=> Resolving record '${name} with big map based resolution algorithm'`);
            const info = yield this.getValidRecord(name);
            this.tracer.trace(`<= Resolved record.`, info === null || info === void 0 ? void 0 : info.record);
            if (!info) {
                return null;
            }
            return {
                name,
                address: info.record.address,
                data: info.record.data,
                expiry: info.expiry,
            };
        });
    }
    resolveReverseRecordDomainInfo(address) {
        return __awaiter(this, void 0, void 0, function* () {
            this.tracer.trace(`=> Resolving reverse record for '${address} with big map based resolution algorithm'`);
            const reverseRecord = yield this.tezosDomainsDataProvider.getReverseRecord(address);
            if (!reverseRecord || !reverseRecord.name) {
                this.tracer.trace(`!! Reverse record is empty.`);
                return null;
            }
            const info = yield this.getValidRecord(reverseRecord.name);
            if (!info) {
                return null;
            }
            this.tracer.trace(`<= Resolved reverse record.`, reverseRecord);
            return {
                address,
                name: reverseRecord.name,
                data: info.record.data,
                expiry: info.expiry,
            };
        });
    }
    getValidRecord(name) {
        return __awaiter(this, void 0, void 0, function* () {
            const record = yield this.tezosDomainsDataProvider.getDomainRecord(name);
            if (!record) {
                this.tracer.trace('!! Record is null.');
                return null;
            }
            if (!record.expiry_key) {
                this.tracer.trace(`!! Validity key is null, record never expires.`);
            }
            const expiry = record.expiry_key ? yield this.tezosDomainsDataProvider.getDomainExpiry(record.expiry_key) : null;
            if (expiry && expiry < new Date()) {
                this.tracer.trace('!! Record is expired.');
                // expired
                return null;
            }
            this.tracer.trace('!! Record is valid.');
            return { record, expiry };
        });
    }
}

const SUPPORTED_NETWORKS = Object.keys(BuiltInAddresses).filter(n => n !== 'custom');
/**
 * Can be used for feature toggles.
 */
function isTezosDomainsSupportedNetwork(network) {
    return SUPPORTED_NETWORKS.includes(network);
}

function generateNonce() {
    if (typeof process != 'undefined' && typeof process.pid == 'number' && process.versions && process.versions.node) {
        return randomInt(0xFFFFFFFFFFFF);
    }
    else {
        return window.crypto.getRandomValues(new Uint32Array(1))[0];
    }
}

export { AddressBook, BytesEncoder, DateEncoder, DomainNameValidationResult, JsonBytesEncoder, LatinDomainNameValidator, LengthDomainNameValidator, NormalizeBytesEncoder, NotSupportedError, RecordMetadata, ResolverDataProviderAdapter, RpcRequest, RpcRequestData, RpcRequestObjectData, RpcRequestScalarData, RpcResponse, RpcResponseData, SmartContractType, StandardRecordMetadataKey, TLDConfigProperty, TezosDomainsValidator, UnsupportedDomainNameValidator, createTracer, encoder, generateNonce, getLabel, getLevel, getParent, getTld, hexToArray, isTezosDomainsSupportedNetwork, normalizeDomainName, stripTld, tokenizeDomainName };
//# sourceMappingURL=core.es2015.js.map
